export default __webpack_public_path__ + "static/media/paper_fold.1b05f276.mp3";